import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    margin-top: 10px;
`;

export const ColorSelector = styled.div.attrs(props => ({
    style: {
        backgroundColor: `hsl(${props.hue}, 100%, 50%)`
    }
}))`
    flex: 1;
    position: relative;

    :before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to right, #fff 0%, rgba(255,255,255,0) 100%);
        z-index: 1;
    }

    :after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to bottom, transparent 0%, #000 100%);
        z-index: 1;
    }
`;

export const HueSelector = styled.div`
    background: linear-gradient(to bottom, hsl(0,100%,50%) 0%, hsl(60,100%,50%) 17%, hsl(120,100%,50%) 33%, hsl(180,100%,50%) 50%, hsl(240,100%,50%) 67%, hsl(300,100%,50%) 83%, hsl(360,100%,50%) 100%);
    height: 200px;
    width: 30px;
    margin-left: 20px;
    position: relative;
`;  

const AlphaSelectorBefore = styled.div.attrs(props => ({
    style: {
        backgroundImage: `linear-gradient(to bottom, ${props.color} 0%, transparent 100%)`
    }
}))`
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export const AlphaSelector = styled.div.attrs(props => ({
    children: [
        <AlphaSelectorBefore key='before' color={props.color} />,
        ...props.children
    ]
}))`
    background: url('${()=>window.basedir}/images/alphabkg.png') repeat 100% 100%;
    height: 200px;
    width: 30px;
    margin-left: 20px;
    margin-left: 20px;
    position: relative;
`;


//saturation brigthness
export const ColorPicker = styled.div.attrs(props => ({
    style: {
        top: (100 - props.brigthness) + '%',
        left: props.saturation + '%',
    }
}))`
    position: absolute;
    top: 0;
    left: 100%;
    z-index: 3;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transform: translate3d(-50%, -50%, 0);
    border: 2px solid #000;

    :before {
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        border: 2px solid #ccc;
        border-radius: 50%;
    }
`;

export const VerticalPicker = styled.div.attrs(props => ({
    style: {
        backgroundColor: props.color,
        top: props.value + '%'
    }
}))`
    position: absolute;
    left: 50%;
    width: calc(100% + 4px);
    height: 15px;
    z-index: 3;
    border-radius: 7px;
    transform: translate3d(-50%, -50%, 0);
    border: 2px solid #000;

    :before {
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        border: 2px solid #ccc;
        border-radius: 7px;
    }
`;

export const ColorRow = styled.div`
    display:flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    margin-bottom: 15px;

    &.hide {
        display: none
    }
`;

export const InputRow = styled.div`
    display:flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;

    
    &.hide {
        display: none
    }
`;

export const HexLabel = styled.div`
    height: 30px;
    color: #999;
    font-size: 12px;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-transform: uppercase;
`;

export const HexInput = styled.input`
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 80px;
    margin-bottom: 10px;
    color: #999;
`;

export const Overlayer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
`;

export const ColorsBase = styled.div`
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
`;


export const Colors = styled.div`
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const ColorBtn = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.color || '#fff',
    }
}))`
    width: 24px;
    height: 24px;
    border-radius: 12px;
    border: 2px solid #666;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    margin-right: 3px;

    &:last-child {
        margin-right: 0;
    }

    &.active {
        border: 4px solid #fff;
    }

    &.active:before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        border-radius: 8px;
        border: 2px solid #111;
    }
`;

export const EditLabel = styled.button`
    height: 30px;
    background-color: transparent;
    border: 1px solid #999;
    color: #999;
    transition: all .3s ease 0s;
    cursor: pointer;

    :hover {
        background-color: #999;
        color: #000;
    }
`;